module.exports = __webpack_public_path__ + "img/f222c5af9c68bd4a3141587e061ab9e7.png";